<template>
    <div class="index">
        <picture>
            <source srcset="@/assets/images/gy_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/gy.png" />
        </picture>
        <div class="topLine">
            <div class="content">
                <div class="title3">关于舟恩</div>
                <div class="flex">
                    <div class="textDiv">
                        <div class="mt20">上海舟恩信息技术有限公司，于2014年6月注册成立。公司秉承 “诚信、执着、卓越、致远”的理念，以“客户满意、员工爱戴、同行尊敬”为目标，致力于为金融、健康、新能源、汽车、房地产、康养等行业提供综合性IT解决方案与咨询服务。</div>
                        <div class="mt8">舟恩信息总部位于上海，在北京、深圳、杭州、成都等10个城市设有分支机构，提供全国服务支持体系，我们的队伍仍在稳步扩大。</div>
                        <div class="mt8">舟恩信息是高新技术企业，通过了CMMI5、ISO9001、ISO20000、ISO27001等认证。具备规范的研发体系、高效的技术团队以及完善的售后服务流程，为客户提高竞争力而做出贡献。</div>
                        <div class="mt8">与客户共赢、与员工共赢、与社会共同发展。同舟共济，感恩有你！</div>
                    </div>
                    <img class="textImg" src="@/assets/images/gy1.png" />
                </div>
            </div>
        </div>
       <div class="lxwm">
            <div class="content">
                <div class="title3">联系我们</div>
                <div class="items mt15">
                    <div class="item bg1">
                        <img src="@/assets/images/gy2.png" />
                        <div class="lb">
                            <div class="min">销售邮箱</div>
                            <div class="max"><a href="mailto:bd@arkgrace.com">bd@arkgrace.com</a></div>
                        </div>
                    </div>
                    <div class="item bg2">
                        <img src="@/assets/images/gy3.png" />
                        <div class="lb">
                            <div class="min">加入我们</div>
                            <div class="max"><a href="mailto:zhaopin@arkgrace.com">zhaopin@arkgrace.com</a></div>
                        </div>
                    </div>
                </div>
                <div class="items pc-item">
                    <div class="item">
                        <div class="title2">上海（总部）</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司</div>
                        <div class="minTitle2 mt10">地址：上海市浦东新区祖冲之路1077弄1105室</div>
                        <div class="minTitle2 mt5">电话：021-50155130</div>
                    </div>
                    <div class="item">
                        <div class="title2">深圳</div>
                        <div class="minTitle2 mt5">舟恩信息技术（深圳）有限公司</div>
                        <div class="minTitle2 mt10">地址：深圳市南山区南头街道南光路286号水木一方大厦A座11D</div>
                        <div class="minTitle2 mt5">电话：0755-82691789</div>
                    </div>
                    <div class="item">
                        <div class="title2">南京</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司南京分公司</div>
                        <div class="minTitle2 mt10">地址：南京市江宁区秣陵街道双龙大道1008号天秀湾花园综合楼401-183</div>
                    </div>
                    <div class="itemEnd">
                        <div class="title2">成都</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司成都分公司</div>
                        <div class="minTitle2 mt10">地址：四川省成都市锦江区华兴正街5号2栋21层1号</div>
                    </div>
                    <div class="item">
                        <div class="title2">武汉</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司武汉分公司</div>
                        <div class="minTitle2 mt10">地址：武汉东湖新技术开发区关东园路2-2号武汉光谷园际商会大厦A座11层15号</div>
                    </div>
                    <div class="item">
                        <div class="title2">广州</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司广州分公司</div>
                        <div class="minTitle2 mt10">地址：广州市天河区菁晖街12号204铺209-31N</div>
                    </div>
                    <div class="item">
                        <div class="title2">北京</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司北京分公司</div>
                        <div class="minTitle2 mt10">地址：北京市怀柔区杨宋镇凤翔东大街9号209-10室</div>
                    </div>
                    <div class="itemEnd">
                        <div class="title2">杭州</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司杭州分公司</div>
                        <div class="minTitle2 mt10">浙江省杭州市滨江区长河街道滨文路200号1幢3层3679室</div>
                    </div>
                    <div class="item">
                        <div class="title2">天津</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司天津分公司</div>
                        <div class="minTitle2 mt10">地址：天津市武清区大碱厂镇杨崔公路东侧52号317室</div>
                    </div>
                    <div class="item">
                        <div class="title2">山东</div>
                        <div class="minTitle2 mt5">上海舟恩信息技术有限公司山东分公司</div>
                        <div class="minTitle2 mt10">地址：山东省青岛市李沧区永年路1号办公楼113-4</div>
                    </div>
                    <div class="item">
                        <div class="title2">香港</div>
                        <div class="minTitle2 mt5">香港舟恩有限公司</div>
                        <div class="minTitle2 mt10">地址：香港九龙新蒲岗大有街3号Maxgrand Plaza 19H室</div>
                    </div>
                </div>
                <div class="mb-item">
                    <div class="botton-swiper content">
                        <el-carousel arrow="never" ref="carousel" :autoplay="false">
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">上海（总部）</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司<br>
                                        地址：上海市浦东新区祖冲之路1077弄1105室<br>
                                        电话：021-50155130
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">深圳</div>
                                    <div class="p">
                                        舟恩信息技术（深圳）有限公司<br>
                                        地址：深圳市南山区南头街道南光路286号水木一方大厦A座11D<br>
                                        电话：0755-82691789
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">南京</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司南京分公司<br>
                                        地址：南京市江宁区秣陵街道双龙大道1008号天秀湾花园综合楼401-183
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">成都</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司成都分公司<br>
                                        地址：四川省成都市锦江区华兴正街5号2栋21层1号
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">武汉</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司武汉分公司<br>
                                        地址：武汉东湖新技术开发区关东园路2-2号武汉光谷园际商会大厦A座11层15号
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">广州</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司广州分公司<br>
                                        地址：广州市天河区菁晖街12号204铺209-31N
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">北京</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司北京分公司<br>
                                        地址：北京市怀柔区杨宋镇凤翔东大街9号209-10室
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="block">
                                    <div class="t">杭州</div>
                                    <div class="p">
                                        上海舟恩信息技术有限公司杭州分公司<br>
                                        浙江省杭州市滨江区长河街道滨文路200号1幢3层3679室
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
       </div>
       <div class="zzry">
            <div class="content botton">
                <div class="title3 mb15">资质荣誉</div>
                <div class="pc">
                    <div class="box">
                        <div class="line mt20">
                            <div class="item">2017</div>
                            <div class="item">2018</div>
                            <div class="item">2019</div>
                            <div class="item">2020</div>
                            <div class="item">2021</div>
                            <div class="item"><div class="dian"></div></div>
                            <div class="item"><div class="dian"></div></div>
                            <div class="item"><div class="dian"></div></div>
                            <div class="item"><div class="dian"></div></div>
                            <div class="item"><div class="dian"></div></div>
                        </div>
                        <div class="lineDiv"></div>
                        <div class="line mt10">
                            <div class="item item2">
                                <img src="@/assets/images/gy4.png" />
                                <div class="lb vl10">
                                    <div class="min">2017年5月</div>
                                    <div class="max">ISO9001质量管理体系认证</div>
                                </div>
                            </div>
                            <div class="item item2">
                                <img src="@/assets/images/gy5.png" />
                                <div class="lb vl10">
                                    <div class="min">2018年6月</div>
                                    <div class="max">CMMI 3级</div>
                                </div>
                            </div>
                            <div class="item item2">
                                <img src="@/assets/images/gy6.png" />
                                <div class="lb vl10">
                                    <div class="min">2019年3月</div>
                                    <div class="max">企业信用等级 AAA</div>
                                </div>
                            </div>
                            <div class="item item2">
                                <img src="@/assets/images/gy7.png" />
                                <div class="lb">
                                    <div class="min">2020年5月</div>
                                    <div class="max">ISO20000信息技术服务管理体系认证</div>
                                </div>
                            </div>
                            <div class="item item2">
                                <img src="@/assets/images/gy9.png" />
                                <div class="lb vl10">
                                    <div class="min">2021年5月</div>
                                    <div class="max">CMMI 5级 </div>
                                </div>
                            </div>
                            <div class="item item2">
                            </div>
                            <div class="item item2">
                            </div>
                            <div class="item item2 mt10">
                                <img src="@/assets/images/gy11.png" />
                                <div class="lb">
                                    <div class="min">2019年9月</div>
                                    <div class="max">ISO27001信息安全管理体系认证</div>
                                </div>
                            </div>
                            <div class="item item2 mt10">
                                <img src="@/assets/images/gy10.png" />
                                <div class="lb vl10">
                                    <div class="min">2020年11月</div>
                                    <div class="max">高新技术企业</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                // var that = this
                // if(that.autoplay == false){
                //     that.autoplay = true;
                // }
            },
            stopAuto() {
                // var that = this
                // if(that.autoplay == true){
                //     that.autoplay = false;
                // }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.botton-swiper .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .mt8 {
            margin-top: 8px;
        }
        .topLine {
            zoom: 1;
            overflow: hidden;
            padding: 40px 0px 30px;
            line-height: 20px;
            .textDiv {
                width: 45%;
                float: left;
            }
            .textImg {
                float: right;
                width: 45%;
            }
        }
        .lxwm {
            background-color: #F5F7FA;
            padding: 30px 0;
            .botton-swiper {
                display: none;
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                
                .item {
                    margin-top: 10px;
                    width: 22%;
                    margin-right: 1%;
                    background-color: #ffffff;
                    padding: 15px 1%;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        .min {
                            font-size: 12px;
                        }
                        .max {
                            font-size: 16px;
                        }
                    }
                }
                .itemEnd {
                    margin-top: 10px;
                    width: 23%;
                    padding: 15px 1%;
                    background-color: #ffffff;
                }
                .bg1 {
                    background: #D7EDF8;
                }
                .bg2 {
                    background: #E2D9FF;
                }
            }
        }
        .zzry {
            .botton {
                padding: 30px 0;
                background: url(../../assets/images/dw.png) no-repeat;
                background-size: 100% 55%;
                .line {
                    display: flex;
                    flex-wrap: wrap; 
                    .item {
                        width: 20%;
                        text-indent: 15px;
                        color: #1094FF;
                        font-size: 20px;
                        font-weight: 600;
                        .dian {
                            width: 10px;
                            height: 10px;
                            background-color: #1094FF;
                            border-radius: 10px;
                            margin-top: 10px;
                            margin-left: 35px;
                        }
                    }
                    .item2 {
                        text-indent: 0px;
                        img {
                            height: 45px;
                            margin-right: 5px;
                        }
                        .lb {
                            display: inline-block;
                            .min {
                                color: #999999;
                                font-size: 12px;
                            }
                            .max {
                                color: #666666;
                                font-size: 13px;
                                max-width: 160px;
                            }
                        }
                        .vl10 {
                            vertical-align: 10px;
                        }
                    }
                }
                .lineDiv {
                    height: 1px;
                    border-top: 2px dashed #1094FF;
                    margin-top: -6px;
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
        position: relative;
    }
    .flashImg {
      height: 100vh;
    }
    .topLine {
        .flex {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        padding: 40px 0 30px;
    }
    .zzry .botton {
        padding: 30px 50px;
    }
  }
}
@media (max-width: 960px) {
    .index {
        .topLine {
            .flex {
                flex-direction: column-reverse;
            }
            .title3 {
                text-align: center;
            }
            .textDiv {
                width: 100%;
                padding: 5px 25px;
                box-sizing: border-box;
            }
            .textImg {
                width: 100%;
                margin-top: 30px;
            }
        }
        .lxwm {
            .items {
                .max {
                    a {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .index {
        .flash {

        }
        .flashImg {
            height: 30vh;
        }
        .lxwm {
            .items {
                .item {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    margin-right: 0;
                    padding: 20px 10px;
                    .lb .min {
                        font-size: 14px;
                    }
                }
            }
            .pc-item {
                display: none;
            }
            .botton-swiper {
                /deep/ .el-carousel__container {
                    height: 200px;
                }
                /deep/ .el-carousel__item {
                    display: flex;
                }
                /deep/ .el-carousel__indicator--horizontal {
                    padding: 0 4px;
                }
                /deep/ .el-carousel__indicators--horizontal {
                    width: 100%;
                    text-align: center;
                    line-height: 1;
                    bottom: 12px;
                }
                /deep/ .el-carousel__button {
                    background-color: #333;
                }
                display: block;
                margin-top: 25px;
                background-color: #fff;
                .block {
                    width: 100%;
                    padding: 20px 15px 0;
                    font-size: 14px;
                    line-height: 1.6;
                }
            }
        }
        .zzry .botton {
            padding: 20px 15px;
            .title3 {
                text-align: center;
            }
            .pc {
                height: 220px;
                position: relative;
                overflow: scroll;
                .box {
                    position: absolute;
                    width: 300%;
                    .line .item {
                        display: flex;
                        align-items: center;
                    }
                    .line .item2 .lb .max {
                        padding-right: 15px;
                    }
                    .line .item2 img {
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>